import { SortOrders } from 'enums/SortOrders'

import {
  compose,
  whiteListColumn,
  updateColumnAttributes,
} from 'utils/overrideModel'

import { CandidateRankingModel } from '../CandidateRanking'

const PhaseSortingObject = {
  sortOrderObject: [
    'null',
    'Validation',
    'Not Applicable',
    'Unknown',
    'Inactive',
    'Discontinued',
    'Paused',
    'Product Launch',
    'Approved',
    'Phase IV',
    'Preclinical',
    'Phase 0',
    'Phase I',
    'Phase I/II',
    'Phase II',
    'Phase II/III',
    'Phase III',
    'Phase III/IV',
  ],
}

export const RespiratoryVaccinesModel = compose<typeof CandidateRankingModel>(
  whiteListColumn([
    'name',
    'latestPhaseManual',
    'sponsors',
    'alternativeNames',
    'vaccineValency',
    'diseaseName',
    'technologyType',
    'targetPopulation',
    'vaccineAdjuvants',
    'affiliates',
    'routeOfAdministration',
    'seasonalOrPandemic',
    'targetViralStrain',
    'latestPhaseManualSource',
  ]),
  updateColumnAttributes('latestPhaseManual', PhaseSortingObject)
)({
  ...CandidateRankingModel,
  name: 'Vaccine Candidates',
  defaultSortOrder: SortOrders.DESC,
  defaultSortKey: 'latestPhaseManual',
})

export const RespiratoryTreatmentsModel = compose<typeof CandidateRankingModel>(
  whiteListColumn([
    'diseaseName',
    'name',
    'alternativeNames',
    'latestPhaseManual',
    'targetPopulation',
    'designationB',
    'technologyType',
    'mechanismOfActionDescription',
    'sponsors',
    'affiliates',
    'routeOfAdministration',
    'latestPhaseManualSource',
  ]),
  updateColumnAttributes('latestPhaseManual', PhaseSortingObject)
)({
  ...CandidateRankingModel,
  name: 'Treatment Candidates',
  defaultSortObject: [
    {
      id: 'latestPhaseManual',
      sortOrder: SortOrders.DESC,
    },
    {
      id: 'designationB',
      sortOrder: SortOrders.DESC,
    },
  ],
})

export const RespiratoryCombinationVaccinesModel = compose<
  typeof CandidateRankingModel
>(
  whiteListColumn([
    'diseaseName',
    'name',
    'alternativeNames',
    'latestPhaseManual',
    'technologyType',
    'targetPopulation',
    'sponsors',
    'affiliates',
    'routeOfAdministration',
    'latestPhaseManualSource',
  ]),
  updateColumnAttributes('latestPhaseManual', PhaseSortingObject)
)({
  ...CandidateRankingModel,
  name: 'Combination vaccines',
  defaultSortOrder: SortOrders.DESC,
  defaultSortKey: 'latestPhaseManual',
})

export const RespiratoryCandidatesAllCombinedModel = compose<
  typeof CandidateRankingModel
>(
  whiteListColumn([
    'name',
    'diseaseName',
    'alternativeNames',
    'latestPhaseManual',
    'technologyType',
    'targetPopulation',
    'vaccineAdjuvants',
    'sponsors',
    'affiliates',
    'routeOfAdministration',
    'designationB',
    'mechanismOfActionDescription',
    'seasonalOrPandemic',
    'targetViralStrain',
    'latestPhaseManualSource',
  ]),
  updateColumnAttributes('latestPhaseManual', PhaseSortingObject)
)({
  ...CandidateRankingModel,
  name: 'All',
  defaultSortOrder: SortOrders.DESC,
  defaultSortKey: 'latestPhaseManual',
})
